import { isDefined } from "@clipboard-health/util-ts";
import { useWorkerGeoLocation } from "@src/appV2/Worker/useWorkerGeoLocation";
import { parseISO } from "date-fns";

import { useShiftBundlesConfig } from "../../Shift/Bundle/useShiftBundlesConfig";
import { useGetOpenShiftsForDates } from "../../Shift/Open/useGetOpenShiftsForDates";
import { isPriorityShift } from "../../Shift/Priority/isPriorityShift";
import { useGetShiftDiscoveryDefaultDateRange } from "../../utils/useGetShiftDiscoveryDefaultDateRange";
import { useShiftDiscoveryUserFiltersContext } from "../Filters/useUserFiltersContext";

export function usePriorityShiftsData() {
  const { dates: dateStrings, distance, includedStates } = useShiftDiscoveryUserFiltersContext();
  const dates = dateStrings.map((dateString) => parseISO(dateString));

  const workerGeoLocation = useWorkerGeoLocation();

  const defaultDateRange = useGetShiftDiscoveryDefaultDateRange();

  const shiftBundlesConfig = useShiftBundlesConfig();

  const { shifts, pagination, ...rest } = useGetOpenShiftsForDates({
    dates,
    dateRange: defaultDateRange,
    filter: {
      area: {
        latitude: workerGeoLocation?.latitude ?? 0,
        longitude: workerGeoLocation?.longitude ?? 0,
        radiusInMiles: distance,
      },
      ...(includedStates?.length && { includedStates }),
    },
    enabled: isDefined(workerGeoLocation),
    // Include offers when bundles are enabled so we can calculate bundle pay
    includeOffers: shiftBundlesConfig.enabled,
  });

  const priorityShifts = shifts.filter((shift) =>
    isPriorityShift({
      priorityTill: shift.attributes.priorityTill,
      window: shift.attributes.window,
    })
  );

  return {
    ...rest,
    shifts: priorityShifts,
    allShifts: shifts,
    pagination,
  };
}
